module.exports = "../../../../platform/assets/pageMainIcon/simple_baobiaochaxunlei7.svg";